import { Component, ViewChild, Input, EventEmitter, Output, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { FidelService, FidelJsLoaderService, MemberQuery, CardLinkingService, CardLinkingQuery, CardLinkOffersService, TransactionType, TransactionService, TransactionQuery, CardLinkOffersQuery, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { __awaiter } from 'tslib';
import { Router, RouterModule } from '@angular/router';
import { Subject, fromEvent } from 'rxjs';
import { exhaustMap, takeUntil, delay, switchAll, switchMap, map, tap } from 'rxjs/operators';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { OwlCarouselSettings } from '@fgb/portal-component-library/src/lib/shared/utilities';
import * as moment from 'moment';
import { DateRangePickerModule } from '@fgb/portal-component-library/src/lib/shared/date-range-picker';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc2 from '@fgb/core';
import * as ɵngcc3 from '@angular/router';
import * as ɵngcc4 from '@fgb/portal-component-library/src/lib/directives';
import * as ɵngcc5 from '@ngx-translate/core';
import * as ɵngcc6 from '@angular/common';
import * as ɵngcc7 from '@fgb/portal-component-library/src/lib/pipes';
import * as ɵngcc8 from 'ngx-owl-carousel-o';
import * as ɵngcc9 from '@fgb/portal-component-library/src/lib/shared/date-range-picker';
import * as ɵngcc10 from '@fgb/portal-component-library/src/lib/shared/loading';

const _c0 = ["linkCard"];
function CardLinkButtonComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "button", 3, 4);
    ɵngcc0.ɵɵlistener("click", function CardLinkButtonComponent_ng_container_0_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); const _r1 = ɵngcc0.ɵɵreference(2); return ctx_r6.modelContent = _r1; });
    ɵngcc0.ɵɵelementStart(4, "span", 5);
    ɵngcc0.ɵɵtext(5, "add_card");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "label", 6);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵpipe(8, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 7);
    ɵngcc0.ɵɵelementStart(10, "button", 3, 4);
    ɵngcc0.ɵɵlistener("click", function CardLinkButtonComponent_ng_container_0_Template_button_click_10_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(); const _r1 = ɵngcc0.ɵɵreference(2); return ctx_r8.modelContent = _r1; });
    ɵngcc0.ɵɵelementStart(12, "span", 5);
    ɵngcc0.ɵɵtext(13, "add_circle_outline");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "label", 6);
    ɵngcc0.ɵɵtext(15);
    ɵngcc0.ɵɵpipe(16, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const linkedCardsCount_r3 = ctx.ngSubscribe;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.cardLinkingSettings.allowMultipleCardLinking == false && linkedCardsCount_r3 > 0);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(8, 4, "fgbcl.card.linking.link.card.button.title"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.cardLinkingSettings.allowMultipleCardLinking == false && linkedCardsCount_r3 > 0);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(16, 6, "fgbcl.card.linking.link.card.button.title"));
} }
function CardLinkButtonComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "div", 9);
    ɵngcc0.ɵɵelementStart(2, "p", 10);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "hr", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 12);
    ɵngcc0.ɵɵelementStart(7, "button", 13);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵpipe(9, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 14);
    ɵngcc0.ɵɵelementStart(11, "p", 10);
    ɵngcc0.ɵɵtext(12);
    ɵngcc0.ɵɵpipe(13, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(14, "fgbcl-card-link-offers-list");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 3, "fgbcl.card.linking.link.offer.modal.title"));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(9, 5, "fgbcl.card.linking.model.active.offer.button.title"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(13, 7, "fgbcl.card.linking.model.activated.offer.button.title"));
} }
function CardLinkedSingleComponent_img_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 15);
} }
function CardLinkedSingleComponent_img_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 16);
} }
function CardLinkedSingleComponent_img_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 17);
} }
function CardLinkedSingleComponent_img_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 18);
} }
function CardLinkedSingleComponent_img_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 19);
} }
function CardLinkedSingleComponent_img_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 20);
} }
function CardLinkedSingleComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 21);
} }
function CardLinkedSingleComponent_button_16_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 22);
    ɵngcc0.ɵɵlistener("click", function CardLinkedSingleComponent_button_16_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); const _r8 = ɵngcc0.ɵɵreference(18); ctx_r10.externalCardId = ctx_r10.linkedCard.ExternalCardId; return ctx_r10.openModel(_r8); });
    ɵngcc0.ɵɵelementStart(1, "span", 23);
    ɵngcc0.ɵɵtext(2, "delete");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(4, 1, "fgbcl.card.linking.delete.card.label"), " ");
} }
function CardLinkedSingleComponent_ng_template_17_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 24);
    ɵngcc0.ɵɵelementStart(1, "span", 25);
    ɵngcc0.ɵɵtext(2, "delete");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "p", 26);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 27);
    ɵngcc0.ɵɵelementStart(7, "p", 28);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵpipe(9, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div");
    ɵngcc0.ɵɵelementStart(11, "button", 29);
    ɵngcc0.ɵɵlistener("click", function CardLinkedSingleComponent_ng_template_17_Template_button_click_11_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.cancel(); });
    ɵngcc0.ɵɵtext(12);
    ɵngcc0.ɵɵpipe(13, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "button", 30);
    ɵngcc0.ɵɵlistener("click", function CardLinkedSingleComponent_ng_template_17_Template_button_click_14_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.deleteLinkedCard(); });
    ɵngcc0.ɵɵtext(15);
    ɵngcc0.ɵɵpipe(16, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(5, 4, "fgbcl.card.linking.delete.card.model.title"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(9, 6, "fgbcl.card.linking.delete.card.model.description"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(13, 8, "fgbcl.card.linking.delete.card.model.cancel.button.text"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(16, 10, "fgbcl.card.linking.delete.card.model.confirm.button.text"), " ");
} }
function CardLinkOfferItemComponent_p_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 14);
    ɵngcc0.ɵɵelementStart(1, "span", 15);
    ɵngcc0.ɵɵtext(2, "star");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(4, 1, "fgbcl.card.linking.feature.offer.title"), " ");
} }
function CardLinkOfferItemComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, "fgbcl.card.linking.succes.offer.online.button.title"), " ");
} }
function CardLinkOfferItemComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, "fgbcl.card.linking.succes.offer.instore.button.title"), " ");
} }
function CardLinkOfferItemComponent_span_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 15);
    ɵngcc0.ɵɵtext(1, " add ");
    ɵngcc0.ɵɵelementEnd();
} }
function CardLinkOfferItemComponent_span_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 15);
    ɵngcc0.ɵɵtext(1, " done ");
    ɵngcc0.ɵɵelementEnd();
} }
function CardLinkOfferItemComponent_span_21_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 15);
    ɵngcc0.ɵɵtext(1, "navigate_next");
    ɵngcc0.ɵɵelementEnd();
} }
const _c1 = function (a0, a1, a2) { return { "add-offer": a0, "added-offer": a1, "view-offer": a2 }; };
function CardLinkOffersListComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelement(2, "fgbcl-card-link-offer-item", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const cardLinkOffer_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("cardLinkOffer", cardLinkOffer_r1)("lcid", ctx_r0.lcid);
} }
function CardLinkedListComponent_2_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fgbcl-card-linked-single", 4);
} if (rf & 2) {
    const card_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("linkedCard", card_r1);
} }
function CardLinkedListComponent_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, CardLinkedListComponent_2_ng_template_0_Template, 1, 1, "ng-template", 3);
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("width", 220);
} }
function CardLinkedTransactionsListComponent_ng_container_23_div_1_div_1_div_1_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 24);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "FortressCurrencyPipe");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const transaction_r8 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngClass", transaction_r8.Amount >= 0 ? "text-success" : "text-danger");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", transaction_r8.Amount >= 0 ? "+" : "", "", ɵngcc0.ɵɵpipeBind2(2, 3, transaction_r8.Amount, "USD"), " ");
} }
function CardLinkedTransactionsListComponent_ng_container_23_div_1_div_1_div_1_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 25);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, "fgbcl.card.linking.transaction.status.pending.text"), " ");
} }
function CardLinkedTransactionsListComponent_ng_container_23_div_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵelementStart(2, "div", 8);
    ɵngcc0.ɵɵelementStart(3, "div", 20);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "uppercase");
    ɵngcc0.ɵɵpipe(6, "UtcToLocaltimePipe");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 21);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 12);
    ɵngcc0.ɵɵtemplate(10, CardLinkedTransactionsListComponent_ng_container_23_div_1_div_1_div_1_div_10_Template, 3, 6, "div", 22);
    ɵngcc0.ɵɵtemplate(11, CardLinkedTransactionsListComponent_ng_container_23_div_1_div_1_div_1_div_11_Template, 3, 3, "div", 23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const transaction_r8 = ctx.$implicit;
    const ctx_r7 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(5, 4, ɵngcc0.ɵɵpipeBind2(6, 6, transaction_r8.TransactionDateUTC, ctx_r7.dateFormat)), " ");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(transaction_r8.TransactionDescription);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", transaction_r8.TransactionDescription != "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", transaction_r8.TransactionDescription == "");
} }
function CardLinkedTransactionsListComponent_ng_container_23_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, CardLinkedTransactionsListComponent_ng_container_23_div_1_div_1_div_1_Template, 12, 9, "div", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const day_r6 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", day_r6.value);
} }
function CardLinkedTransactionsListComponent_ng_container_23_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵtemplate(1, CardLinkedTransactionsListComponent_ng_container_23_div_1_div_1_Template, 2, 1, "div", 17);
    ɵngcc0.ɵɵpipe(2, "keyvalue");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const transactions_r3 = ɵngcc0.ɵɵnextContext().ngIf;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind2(2, 1, transactions_r3, ctx_r4.keepOrder));
} }
function CardLinkedTransactionsListComponent_ng_container_23_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CardLinkedTransactionsListComponent_ng_container_23_div_1_Template, 3, 4, "div", 15);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.hasTransactions);
} }
function CardLinkedTransactionsListComponent_ng_container_25_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 26);
    ɵngcc0.ɵɵelement(2, "img", 27);
    ɵngcc0.ɵɵelementStart(3, "h5", 28);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "p", 29);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵpipe(8, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(5, 2, "fgbcl.card.linking.no.transaction.date.label"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(8, 4, "fgbcl.card.linking.no.transaction.date.description"), " ");
} }
function CardLinkedTransactionsListComponent_div_26_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 26);
    ɵngcc0.ɵɵelement(1, "fgbcl-loading");
    ɵngcc0.ɵɵelementEnd();
} }
const _c2 = function (a0, a1) { return { "btn-selected": a0, "btn-not-selected": a1 }; };
function AffiliatesOffersCategoryFilterComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵlistener("click", function AffiliatesOffersCategoryFilterComponent_div_1_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const category_r1 = ctx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); ctx_r2.categoryTagId = category_r1.TagId; return ctx_r2.categoryEmitter(); });
    ɵngcc0.ɵɵelementStart(1, "p", 3);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const category_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(2, _c2, ctx_r0.categoryTagId == category_r1.TagId, ctx_r0.categoryTagId != category_r1.TagId));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(category_r1.Name);
} }
const _c3 = ["shopNowBtn"];
function CardLinkOfferDetailsComponent_div_23_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 26);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, "fgbcl.card.linking.succes.offer.online.button.title"), " ");
} }
function CardLinkOfferDetailsComponent_div_23_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 27);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, "fgbcl.card.linking.succes.offer.instore.button.title"), " ");
} }
function CardLinkOfferDetailsComponent_div_23_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 23);
    ɵngcc0.ɵɵtemplate(1, CardLinkOfferDetailsComponent_div_23_div_1_Template, 3, 3, "div", 24);
    ɵngcc0.ɵɵtemplate(2, CardLinkOfferDetailsComponent_div_23_div_2_Template, 3, 3, "div", 25);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.cardLinkOfferDtail.OfferLocations == 1 || ctx_r0.cardLinkOfferDtail.OfferLocations == 3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.cardLinkOfferDtail.OfferLocations == 2 || ctx_r0.cardLinkOfferDtail.OfferLocations == 3);
} }
const _c4 = function (a0) { return { "tab-disable": a0 }; };
function CardLinkOfferDetailsComponent_ng_container_28_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "p", 15);
    ɵngcc0.ɵɵlistener("click", function CardLinkOfferDetailsComponent_ng_container_28_Template_p_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.currentTab = "viewexemptios"; });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c4, ctx_r1.currentTab != "viewexemptios"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 2, "fgbcl.offer.detail.tab-viewexem-text"), " ");
} }
function CardLinkOfferDetailsComponent_p_31_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "currentLanguageContent");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind3(2, 1, ctx_r2.cardLinkOfferDtail.Content, ctx_r2.currentLcid, "description"), " ");
} }
function CardLinkOfferDetailsComponent_p_32_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r13.cardLinkOfferDtail.TermsAndConditions, " ");
} }
function CardLinkOfferDetailsComponent_p_32_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtemplate(1, CardLinkOfferDetailsComponent_p_32_ng_container_1_Template, 2, 1, "ng-container", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.cardLinkOfferDtail.TermsAndConditionsType == 1);
} }
function CardLinkOfferDetailsComponent_button_33_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 28);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, "fgbcl.offer.detail.activate.offer.button.text"), " ");
} }
function CardLinkOfferDetailsComponent_button_34_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 29, 30);
    ɵngcc0.ɵɵlistener("click", function CardLinkOfferDetailsComponent_button_34_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(); const _r7 = ɵngcc0.ɵɵreference(37); ctx_r15.selectedOffer = ctx_r15.cardLinkOfferDtail; return ctx_r15.modelContent = _r7; });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 1, "fgbcl.offer.detail.shop.now.button.text"), " ");
} }
function CardLinkOfferDetailsComponent_div_35_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 31);
    ɵngcc0.ɵɵelementStart(1, "button", 32);
    ɵngcc0.ɵɵelementStart(2, "span", 11);
    ɵngcc0.ɵɵtext(3, "done");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "p", 33);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(6, 1, "fgbcl.offer.detail.activated.offer.button.text"), " ");
} }
function CardLinkOfferDetailsComponent_ng_template_36_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fgbcl-card-link-external-url-modal", 34);
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("companyImageUrl", ctx_r8.selectedOffer.CompanyImageUrl)("navigationUrl", ctx_r8.cardLinkActivateOffer.RedirectUrl)("clubImageUrl", ctx_r8.clubImageUrl);
} }
function CardLinkExternalUrlModalComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "h1");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "p");
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 3);
    ɵngcc0.ɵɵelementStart(9, "div", 4);
    ɵngcc0.ɵɵelementStart(10, "div", 5);
    ɵngcc0.ɵɵelementStart(11, "div", 6);
    ɵngcc0.ɵɵelement(12, "img", 7);
    ɵngcc0.ɵɵpipe(13, "contentImage");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "div", 8);
    ɵngcc0.ɵɵelementStart(15, "div", 9);
    ɵngcc0.ɵɵelementStart(16, "div", 10);
    ɵngcc0.ɵɵtext(17, "arrow_forward_ios");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(18, "div", 11);
    ɵngcc0.ɵɵtext(19, "arrow_forward_ios");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(20, "div", 9);
    ɵngcc0.ɵɵelementStart(21, "div", 10);
    ɵngcc0.ɵɵtext(22, "arrow_forward_ios");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(23, "div", 11);
    ɵngcc0.ɵɵtext(24, "arrow_forward_ios");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(25, "div", 5);
    ɵngcc0.ɵɵelementStart(26, "div", 6);
    ɵngcc0.ɵɵelement(27, "img", 7);
    ɵngcc0.ɵɵpipe(28, "contentImage");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(29, "div", 12);
    ɵngcc0.ɵɵelementStart(30, "p", 13);
    ɵngcc0.ɵɵtext(31);
    ɵngcc0.ɵɵpipe(32, "translate");
    ɵngcc0.ɵɵelementStart(33, "a", 14);
    ɵngcc0.ɵɵelementStart(34, "strong");
    ɵngcc0.ɵɵtext(35);
    ɵngcc0.ɵɵpipe(36, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(37);
    ɵngcc0.ɵɵpipe(38, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(4, 8, "fgbcl.card.link.external.url.model.title"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(7, 10, "fgbcl.card.link.external.url.model.description"), " - Earn 1 Point per 1");
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("src", ɵngcc0.ɵɵpipeBind2(13, 12, ctx_r0.clubImageUrl, "7"), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(15);
    ɵngcc0.ɵɵproperty("src", ɵngcc0.ɵɵpipeBind2(28, 15, ctx_r0.companyImageUrl, "7"), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(32, 18, "fgbcl.card.link.external.url.model.first.instruction"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r0.navigationUrl, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(36, 20, "fgbcl.card.link.external.url.model.click.here"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(38, 22, "fgbcl.card.link.external.url.model.second.instruction"), " ");
} }
function CardLinkExternalUrlModalComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵelementStart(1, "p", 16);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 1, "fgbcl.card.link.external.wrong.url.text"), "");
} }
function CardLinkingFeaturedOffersComponent_ng_container_0_div_1_ng_container_3_ng_template_1_div_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, "fgbcl.card.linking.succes.offer.online.button.title"), " ");
} }
function CardLinkingFeaturedOffersComponent_ng_container_0_div_1_ng_container_3_ng_template_1_div_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, "fgbcl.card.linking.succes.offer.instore.button.title"), " ");
} }
function CardLinkingFeaturedOffersComponent_ng_container_0_div_1_ng_container_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵelement(2, "img", 9);
    ɵngcc0.ɵɵpipe(3, "contentImage");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 10);
    ɵngcc0.ɵɵelementStart(5, "div", 11);
    ɵngcc0.ɵɵelement(6, "img", 9);
    ɵngcc0.ɵɵpipe(7, "contentImage");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 12);
    ɵngcc0.ɵɵelementStart(9, "p", 13);
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵpipe(11, "currentLanguageContent");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "p", 14);
    ɵngcc0.ɵɵtext(13);
    ɵngcc0.ɵɵpipe(14, "shortText");
    ɵngcc0.ɵɵpipe(15, "currentLanguageContent");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "div", 15);
    ɵngcc0.ɵɵtemplate(17, CardLinkingFeaturedOffersComponent_ng_container_0_div_1_ng_container_3_ng_template_1_div_17_Template, 3, 3, "div", 16);
    ɵngcc0.ɵɵtemplate(18, CardLinkingFeaturedOffersComponent_ng_container_0_div_1_ng_container_3_ng_template_1_div_18_Template, 3, 3, "div", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const offer_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r5 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("src", ɵngcc0.ɵɵpipeBind2(3, 6, offer_r4.ImageUrl, "6"), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("src", ɵngcc0.ɵɵpipeBind2(7, 9, offer_r4.CompanyImageUrl, "6"), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind3(11, 12, offer_r4.Content, ctx_r5.currentLcid, "Name"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(14, 16, ɵngcc0.ɵɵpipeBind3(15, 19, offer_r4.Content, ctx_r5.currentLcid, "description"), 30), " ");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", offer_r4.OfferLocations == 1 || offer_r4.OfferLocations == 3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", offer_r4.OfferLocations == 2 || offer_r4.OfferLocations == 3);
} }
function CardLinkingFeaturedOffersComponent_ng_container_0_div_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CardLinkingFeaturedOffersComponent_ng_container_0_div_1_ng_container_3_ng_template_1_Template, 19, 23, "ng-template", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("width", 301);
} }
function CardLinkingFeaturedOffersComponent_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "owl-carousel-o", 4);
    ɵngcc0.ɵɵtemplate(3, CardLinkingFeaturedOffersComponent_ng_container_0_div_1_ng_container_3_Template, 2, 1, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const featuredOffers_r1 = ɵngcc0.ɵɵnextContext().ngIf;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("options", ctx_r2.customOptions);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", featuredOffers_r1);
} }
function CardLinkingFeaturedOffersComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CardLinkingFeaturedOffersComponent_ng_container_0_div_1_Template, 4, 2, "div", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const featuredOffers_r1 = ctx.ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !!featuredOffers_r1.length);
} }
class CardLinkButtonComponent {
    constructor(modalService, fidelService, fidelJsLoaderService, memberQuery, cardLinkingService, router, cardLinkingQuery) {
        this.modalService = modalService;
        this.fidelService = fidelService;
        this.fidelJsLoaderService = fidelJsLoaderService;
        this.memberQuery = memberQuery;
        this.cardLinkingService = cardLinkingService;
        this.router = router;
        this.cardLinkingQuery = cardLinkingQuery;
        this.hideAddress = false;
        this.showCancelButton = false;
        this._destroyed$ = new Subject();
        /** Default card linking settings are set if no input is passed */
        this.cardLinkingSettings = {
            allowMultipleCardLinking: true,
        };
    }
    ngOnInit() {
        this.linkedCardsCount$ = this.cardLinkingQuery.selectCount();
    }
    /**
    * to prevent multiple calls
    * fromEvent will make click action to button string
    * and the in pipe exhaustMap will make the call to fidle model
    * and privent if user click multiple time
    * after subscription will check if model loaded successfully.
    * a
    */
    ngAfterViewInit() {
        fromEvent(this.linkCardButton.nativeElement, 'click')
            .pipe(exhaustMap(() => this.linkcard()), takeUntil(this._destroyed$), delay(50), switchAll())
            .subscribe((status) => {
            if (status == 'loaded') {
                this.cardLinkedStatus();
                this.fidelService.linkcard(this.memberQuery.getUserContext().memberId, {}, this.fedilCallBack);
            }
        });
    }
    /**
     * open popup for linking the card.
     * retrun either error if there is an issue while linking or Card details if successfully linked.
     * @param content to open the NgbModal for offers.
     */
    linkcard() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.fidelJsLoaderService.loadJs();
        });
    }
    /**
     * Implementation of fedil callback function.
     * callbackSuccess will call when card successfully link and callbackFailed will call if there is any issue.
     * @param content to open the NgbModal for offers.
     */
    cardLinkedStatus() {
        this.fedilCallBack = {
            callbackSuccess: (card) => {
                if (card) {
                    setTimeout(() => {
                        this.cardLinkingService.fetchFidelLinkedCard().toPromise();
                        this.router.navigateByUrl('/linkcardSuccess');
                    }, 1600);
                }
            },
            callbackFailed: (error) => {
                if (error) {
                }
            },
        };
    }
    /**
     * open NgbModal for offers after successfully link the card.
     * callbackSuccess will call when card successfully link and callbackFailed will call if there is any issue.
     * @param content to open the NgbModal for offers.
     */
    openCardModal() {
        this.showCancelButton = false;
        this.hideAddress = false;
        this.modalService.open(this.modelContent, { ariaLabelledBy: 'modal-basic-title' });
    }
    /**
     * dismiss the offer model.
     */
    cancel() {
        this.modalService.dismissAll();
    }
    /**
     * Unsubscribe the observables on distroy
     */
    ngOnDestroy() {
        this._destroyed$.next();
        this._destroyed$.complete();
    }
}
CardLinkButtonComponent.ɵfac = function CardLinkButtonComponent_Factory(t) { return new (t || CardLinkButtonComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgbModal), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.FidelService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.FidelJsLoaderService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.MemberQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.CardLinkingService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.CardLinkingQuery)); };
CardLinkButtonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CardLinkButtonComponent, selectors: [["fgbcl-card-link-button"]], viewQuery: function CardLinkButtonComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 1);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.linkCardButton = _t.first);
    } }, inputs: { cardLinkingSettings: "cardLinkingSettings" }, decls: 3, vars: 1, consts: [[4, "ngSubscribe"], ["addNewCardForm", ""], [1, "d-none", "d-lg-block"], [1, "btn", "add-card-link", 3, "disabled", "click"], ["linkCard", ""], [1, "icon", "material-icons"], [1, "card-link-label"], [1, "d-block", "d-lg-none"], [1, "container", "p-2", "overflow-auto"], [1, "m-2"], [1, "font-weight-bold"], [1, "horizontal-line"], [1, "header", "d-flex", "flex-row", "justify-content-center", "my-10"], [1, "btn", "btn-success"], [1, "container"]], template: function CardLinkButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, CardLinkButtonComponent_ng_container_0_Template, 17, 8, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, CardLinkButtonComponent_ng_template_1_Template, 15, 9, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngSubscribe", ctx.linkedCardsCount$);
    } }, directives: function () { return [ɵngcc4.NgSubscribeDirective, CardLinkOffersListComponent]; }, pipes: function () { return [ɵngcc5.TranslatePipe]; }, styles: [""] });
CardLinkButtonComponent.ctorParameters = () => [
    { type: NgbModal },
    { type: FidelService },
    { type: FidelJsLoaderService },
    { type: MemberQuery },
    { type: CardLinkingService },
    { type: Router },
    { type: CardLinkingQuery }
];
CardLinkButtonComponent.propDecorators = {
    linkCardButton: [{ type: ViewChild, args: ['linkCard',] }],
    cardLinkingSettings: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardLinkButtonComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-card-link-button',
                template: "<ng-container *ngSubscribe=\"linkedCardsCount$ as linkedCardsCount\">\r\n  <div class=\"d-none d-lg-block\">\r\n    <button\r\n      #linkCard\r\n      class=\"btn add-card-link\"\r\n      (click)=\"modelContent = addNewCardForm\"\r\n      [disabled]=\"cardLinkingSettings.allowMultipleCardLinking == false && linkedCardsCount > 0\"\r\n    >\r\n      <span class=\"icon material-icons\">add_card</span>\r\n      <label class=\"card-link-label\">{{ 'fgbcl.card.linking.link.card.button.title' | translate }}</label>\r\n    </button>\r\n  </div>\r\n\r\n  <div class=\"d-block d-lg-none\">\r\n    <button\r\n      #linkCard\r\n      class=\"btn add-card-link\"\r\n      (click)=\"modelContent = addNewCardForm\"\r\n      [disabled]=\"cardLinkingSettings.allowMultipleCardLinking == false && linkedCardsCount > 0\"\r\n    >\r\n      <span class=\"icon material-icons\">add_circle_outline</span>\r\n      <label class=\"card-link-label\">{{ 'fgbcl.card.linking.link.card.button.title' | translate }}</label>\r\n    </button>\r\n  </div>\r\n</ng-container>\r\n\r\n<ng-template #addNewCardForm let-modal>\r\n  <div class=\"container p-2 overflow-auto\">\r\n    <div class=\"m-2\">\r\n      <p class=\"font-weight-bold\">{{ 'fgbcl.card.linking.link.offer.modal.title' | translate }}</p>\r\n      <hr class=\"horizontal-line\" />\r\n    </div>\r\n    <div class=\"header d-flex flex-row justify-content-center my-10\">\r\n      <button class=\"btn btn-success\">{{ 'fgbcl.card.linking.model.active.offer.button.title' | translate }}</button>\r\n    </div>\r\n    <div class=\"container\">\r\n      <p class=\"font-weight-bold\">{{ 'fgbcl.card.linking.model.activated.offer.button.title' | translate }}</p>\r\n      <fgbcl-card-link-offers-list></fgbcl-card-link-offers-list>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc1.NgbModal }, { type: ɵngcc2.FidelService }, { type: ɵngcc2.FidelJsLoaderService }, { type: ɵngcc2.MemberQuery }, { type: ɵngcc2.CardLinkingService }, { type: ɵngcc3.Router }, { type: ɵngcc2.CardLinkingQuery }]; }, { cardLinkingSettings: [{
            type: Input
        }], linkCardButton: [{
            type: ViewChild,
            args: ['linkCard']
        }] }); })();

class CardLinkedSingleComponent {
    constructor(cardLinkingServices, modalService) {
        this.cardLinkingServices = cardLinkingServices;
        this.modalService = modalService;
        this.deleteCard = false;
    }
    ngOnInit() { }
    /**
     * Delete the linked Card.
     * @param cardId select card id.
     */
    deleteLinkedCard() {
        this.cardLinkingServices.deleteCard(this.externalCardId).toPromise();
        this.cancel();
    }
    /**
     * Open confirmation model for Delete the linked Card.
     * @param content model id.
     */
    openModel(content) {
        this.deleteCard = !this.deleteCard;
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
    }
    /**
     * close confirmation model for Delete the linked Card.
     */
    cancel() {
        this.modalService.dismissAll();
    }
}
CardLinkedSingleComponent.ɵfac = function CardLinkedSingleComponent_Factory(t) { return new (t || CardLinkedSingleComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.CardLinkingService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgbModal)); };
CardLinkedSingleComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CardLinkedSingleComponent, selectors: [["fgbcl-card-linked-single"]], inputs: { linkedCard: "linkedCard" }, decls: 19, vars: 11, consts: [["id", "", 1, "card-linked-single"], [1, "card-linked-action-icon"], [1, "material-icons", 3, "click"], [1, "card-linked-single-footer"], [1, "card-number"], [3, "ngSwitch"], ["class", "payment-logo", "src", "../../../../../assets/images/payment-icons/_Mastercard.svg", 4, "ngSwitchCase"], ["class", "payment-logo", "src", "../../../../../assets/images/payment-icons/_AMEX.svg", 4, "ngSwitchCase"], ["class", "payment-logo", "src", "../../../../../assets/images/payment-icons/_Visa.svg", 4, "ngSwitchCase"], ["class", "payment-logo", "src", "../../../../../assets/images/payment-icons/_Discover.svg", 4, "ngSwitchCase"], ["class", "payment-logo", "src", "../../../../../assets/images/payment-icons/_JCB.svg", 4, "ngSwitchCase"], ["class", "payment-logo", "src", "../../../../../assets/images/payment-icons/_UnionPay.svg", 4, "ngSwitchCase"], ["class", "payment-logo", 4, "ngSwitchDefault"], ["class", "card-linked-delete-button", 3, "click", 4, "ngIf"], ["content", ""], ["src", "../../../../../assets/images/payment-icons/_Mastercard.svg", 1, "payment-logo"], ["src", "../../../../../assets/images/payment-icons/_AMEX.svg", 1, "payment-logo"], ["src", "../../../../../assets/images/payment-icons/_Visa.svg", 1, "payment-logo"], ["src", "../../../../../assets/images/payment-icons/_Discover.svg", 1, "payment-logo"], ["src", "../../../../../assets/images/payment-icons/_JCB.svg", 1, "payment-logo"], ["src", "../../../../../assets/images/payment-icons/_UnionPay.svg", 1, "payment-logo"], [1, "payment-logo"], [1, "card-linked-delete-button", 3, "click"], [1, "material-icons"], [1, "modal-body", "text-center", "d-flex", "align-items-center", "justify-content-center"], [1, "material-icons", "confim-model-delete-icon"], [1, "confim-model-delete-title"], [1, "modal-footer", "justify-content-center"], [1, "confirmation-text"], ["type", "button", 1, "btn", "btn-danger", "mr-3", 3, "click"], ["type", "button", 1, "btn", "btn-success", 3, "click"]], template: function CardLinkedSingleComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵlistener("click", function CardLinkedSingleComponent_Template_span_click_2_listener() { return ctx.deleteCard = !ctx.deleteCard; });
        ɵngcc0.ɵɵtext(3, "more_horiz");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "p", 4);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵpipe(7, "creditCardNumber");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementContainerStart(8, 5);
        ɵngcc0.ɵɵtemplate(9, CardLinkedSingleComponent_img_9_Template, 1, 0, "img", 6);
        ɵngcc0.ɵɵtemplate(10, CardLinkedSingleComponent_img_10_Template, 1, 0, "img", 7);
        ɵngcc0.ɵɵtemplate(11, CardLinkedSingleComponent_img_11_Template, 1, 0, "img", 8);
        ɵngcc0.ɵɵtemplate(12, CardLinkedSingleComponent_img_12_Template, 1, 0, "img", 9);
        ɵngcc0.ɵɵtemplate(13, CardLinkedSingleComponent_img_13_Template, 1, 0, "img", 10);
        ɵngcc0.ɵɵtemplate(14, CardLinkedSingleComponent_img_14_Template, 1, 0, "img", 11);
        ɵngcc0.ɵɵtemplate(15, CardLinkedSingleComponent_div_15_Template, 1, 0, "div", 12);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(16, CardLinkedSingleComponent_button_16_Template, 5, 3, "button", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(17, CardLinkedSingleComponent_ng_template_17_Template, 17, 12, "ng-template", null, 14, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(7, 9, ctx.linkedCard.CardNumber));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.linkedCard.CardType);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", 1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", 2);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", 3);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", 4);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", 5);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", 8);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.deleteCard);
    } }, directives: [ɵngcc6.NgSwitch, ɵngcc6.NgSwitchCase, ɵngcc6.NgSwitchDefault, ɵngcc6.NgIf], pipes: [ɵngcc7.CreditCardNumberPipe, ɵngcc5.TranslatePipe], styles: [""] });
CardLinkedSingleComponent.ctorParameters = () => [
    { type: CardLinkingService },
    { type: NgbModal }
];
CardLinkedSingleComponent.propDecorators = {
    linkedCard: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardLinkedSingleComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-card-linked-single',
                template: "<div class=\"card-linked-single\" id=\"\">\r\n  <div class=\"card-linked-action-icon\">\r\n    <span (click)=\"deleteCard = !deleteCard\" class=\"material-icons\">more_horiz</span>\r\n  </div>\r\n  <div class=\"card-linked-single-footer\">\r\n    <p class=\"card-number\">{{ linkedCard!.CardNumber | creditCardNumber }}</p>\r\n    <ng-container [ngSwitch]=\"linkedCard!.CardType\">\r\n      <img class=\"payment-logo\" *ngSwitchCase=\"1\" src=\"../../../../../assets/images/payment-icons/_Mastercard.svg\" />\r\n      <img class=\"payment-logo\" *ngSwitchCase=\"2\" src=\"../../../../../assets/images/payment-icons/_AMEX.svg\" />\r\n      <img class=\"payment-logo\" *ngSwitchCase=\"3\" src=\"../../../../../assets/images/payment-icons/_Visa.svg\" />\r\n      <img class=\"payment-logo\" *ngSwitchCase=\"4\" src=\"../../../../../assets/images/payment-icons/_Discover.svg\" />\r\n      <img class=\"payment-logo\" *ngSwitchCase=\"5\" src=\"../../../../../assets/images/payment-icons/_JCB.svg\" />\r\n      <img class=\"payment-logo\" *ngSwitchCase=\"8\" src=\"../../../../../assets/images/payment-icons/_UnionPay.svg\" />\r\n      <div class=\"payment-logo\" *ngSwitchDefault></div>\r\n    </ng-container>\r\n  </div>\r\n  <button\r\n    *ngIf=\"deleteCard\"\r\n    (click)=\"externalCardId = linkedCard!.ExternalCardId; openModel(content)\"\r\n    class=\"card-linked-delete-button\"\r\n  >\r\n    <span class=\"material-icons\">delete</span> {{ 'fgbcl.card.linking.delete.card.label' | translate }}\r\n  </button>\r\n</div>\r\n\r\n<ng-template #content let-modal>\r\n  <div class=\"modal-body text-center d-flex align-items-center justify-content-center\">\r\n    <span class=\"material-icons confim-model-delete-icon\">delete</span>\r\n      <p class=\"confim-model-delete-title\">{{ 'fgbcl.card.linking.delete.card.model.title' | translate }}</p>\r\n  </div>\r\n  <div class=\"modal-footer justify-content-center\">\r\n    <p class=\"confirmation-text\">{{ 'fgbcl.card.linking.delete.card.model.description' | translate }}</p>\r\n    <div>\r\n      <button type=\"button\" class=\"btn btn-danger mr-3\" (click)=\"cancel()\">\r\n        {{ 'fgbcl.card.linking.delete.card.model.cancel.button.text' | translate }}\r\n      </button>\r\n      <button type=\"button\" class=\"btn btn-success\" (click)=\"deleteLinkedCard()\">\r\n        {{ 'fgbcl.card.linking.delete.card.model.confirm.button.text' | translate }}\r\n      </button>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc2.CardLinkingService }, { type: ɵngcc1.NgbModal }]; }, { linkedCard: [{
            type: Input
        }] }); })();

class CardLinkOfferItemComponent {
    constructor(cardLinkOffersService, router) {
        this.cardLinkOffersService = cardLinkOffersService;
        this.router = router;
        this._destroyed$ = new Subject();
        this.activatedOfferID = 0;
    }
    ngOnInit() { }
    /**
     * activate offer by offer ID
     * navigate to the external url
     * navigate to detail page
     * when user click on any button this function will exicute and check
     * some condition according to the offerTyper and CustomerOfferStatus
     * if offer is already active it will move on detail page
     * if offertype !=6 it will call the api to get the url and then will move on
     * company website
     * if offer is not activated it will call the api to activate the offer
     * @param offer to get the offer id customerOfferStatus offerType and imageurl
     * @param content to open the ngbModel to display the navigation progress
     */
    offerAction(offer) {
        if (offer.OfferType == 6 && offer.CustomerOfferStatus == 0) {
            this.activateOffer(offer);
        }
        else {
            this.router.navigateByUrl('/offerdetail/' + offer.OfferId);
        }
    }
    /**
     * activate offer by offer ID
     * @param offer to get the offerId to activate the offer by Id
     */
    activateOffer(offer) {
        this.cardLinkOffersService.activateOffer(offer.OfferId).pipe(takeUntil(this._destroyed$)).subscribe();
    }
    ngOnDestroy() {
        this._destroyed$.next();
        this._destroyed$.complete();
    }
}
CardLinkOfferItemComponent.ɵfac = function CardLinkOfferItemComponent_Factory(t) { return new (t || CardLinkOfferItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.CardLinkOffersService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.Router)); };
CardLinkOfferItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CardLinkOfferItemComponent, selectors: [["fgbcl-card-link-offer-item"]], inputs: { cardLinkOffer: "cardLinkOffer", lcid: "lcid" }, decls: 22, vars: 29, consts: [[1, "offer-item", "justify-content-between", "w-100"], [1, "d-flex", "cursor-pointer", 3, "routerLink"], [1, "offer-item-image"], [3, "src"], [1, "Offer-text-block"], ["class", "feature-Offer-text", 4, "ngIf"], [1, "Offer-header-text"], [1, "Offer-des-text"], [1, "btn-online-instore-block"], ["class", "chip btn-online", 4, "ngIf"], ["class", "chip btn-instore", 4, "ngIf"], [1, "offer-button-block"], [1, "offer-button", 3, "ngClass", "click"], ["class", "icon material-icons", 4, "ngIf"], [1, "feature-Offer-text"], [1, "icon", "material-icons"], [1, "chip", "btn-online"], [1, "chip", "btn-instore"]], template: function CardLinkOfferItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelement(3, "img", 3);
        ɵngcc0.ɵɵpipe(4, "contentImage");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵtemplate(6, CardLinkOfferItemComponent_p_6_Template, 5, 3, "p", 5);
        ɵngcc0.ɵɵelementStart(7, "p", 6);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵpipe(9, "currentLanguageContent");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "p", 7);
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵpipe(12, "shortText");
        ɵngcc0.ɵɵpipe(13, "currentLanguageContent");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "div", 8);
        ɵngcc0.ɵɵtemplate(15, CardLinkOfferItemComponent_div_15_Template, 3, 3, "div", 9);
        ɵngcc0.ɵɵtemplate(16, CardLinkOfferItemComponent_div_16_Template, 3, 3, "div", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "div", 11);
        ɵngcc0.ɵɵelementStart(18, "button", 12);
        ɵngcc0.ɵɵlistener("click", function CardLinkOfferItemComponent_Template_button_click_18_listener() { return ctx.offerAction(ctx.cardLinkOffer); });
        ɵngcc0.ɵɵtemplate(19, CardLinkOfferItemComponent_span_19_Template, 2, 0, "span", 13);
        ɵngcc0.ɵɵtemplate(20, CardLinkOfferItemComponent_span_20_Template, 2, 0, "span", 13);
        ɵngcc0.ɵɵtemplate(21, CardLinkOfferItemComponent_span_21_Template, 2, 0, "span", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("routerLink", "/offerdetail/" + ctx.cardLinkOffer.OfferId);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("src", ɵngcc0.ɵɵpipeBind2(4, 11, ctx.cardLinkOffer.CompanyImageUrl, "7"), ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.cardLinkOffer.Favorite == 1);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind3(9, 14, ctx.cardLinkOffer == null ? null : ctx.cardLinkOffer.Content, ctx.lcid, "Name"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(12, 18, ɵngcc0.ɵɵpipeBind3(13, 21, ctx.cardLinkOffer == null ? null : ctx.cardLinkOffer.Content, ctx.lcid, "description"), 45), " ");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.cardLinkOffer.OfferLocations == 1 || ctx.cardLinkOffer.OfferLocations == 3);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.cardLinkOffer.OfferLocations == 2 || ctx.cardLinkOffer.OfferLocations == 3);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(25, _c1, ctx.cardLinkOffer.CustomerOfferStatus == 0 && ctx.cardLinkOffer.OfferType == 6, ctx.cardLinkOffer.CustomerOfferStatus == 1 && ctx.cardLinkOffer.OfferType == 6, ctx.cardLinkOffer.OfferType != 6));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.cardLinkOffer.CustomerOfferStatus == 0 && ctx.cardLinkOffer.OfferType == 6);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.cardLinkOffer.CustomerOfferStatus == 1 && ctx.cardLinkOffer.OfferType == 6);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.cardLinkOffer.OfferType != 6);
    } }, directives: [ɵngcc3.RouterLink, ɵngcc6.NgIf, ɵngcc6.NgClass], pipes: [ɵngcc7.ContentImagePipe, ɵngcc7.ContentLanguageFilterPipe, ɵngcc7.LongtoShortTextPipe, ɵngcc5.TranslatePipe], styles: [""] });
CardLinkOfferItemComponent.ctorParameters = () => [
    { type: CardLinkOffersService },
    { type: Router }
];
CardLinkOfferItemComponent.propDecorators = {
    cardLinkOffer: [{ type: Input }],
    lcid: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardLinkOfferItemComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-card-link-offer-item',
                template: "<div class=\"offer-item justify-content-between w-100\">\r\n  <div class=\"d-flex cursor-pointer\" [routerLink]=\"'/offerdetail/' + cardLinkOffer.OfferId\">\r\n    <div class=\"offer-item-image\">\r\n      <img [src]=\"cardLinkOffer.CompanyImageUrl | contentImage: '7'\" />\r\n    </div>\r\n    <div class=\"Offer-text-block\">\r\n      <p *ngIf=\"cardLinkOffer.Favorite == 1\" class=\"feature-Offer-text\">\r\n        <span class=\"icon material-icons\">star</span>{{ 'fgbcl.card.linking.feature.offer.title' | translate }}\r\n      </p>\r\n\r\n      <p class=\"Offer-header-text\">{{ cardLinkOffer?.Content | currentLanguageContent: lcid:'Name' }}</p>\r\n      <p class=\"Offer-des-text\">\r\n        {{ cardLinkOffer?.Content | currentLanguageContent: lcid:'description' | shortText: 45 }}\r\n      </p>\r\n\r\n      <div class=\"btn-online-instore-block\">\r\n        <div *ngIf=\"cardLinkOffer.OfferLocations == 1 || cardLinkOffer.OfferLocations == 3\" class=\"chip btn-online\">\r\n          {{ 'fgbcl.card.linking.succes.offer.online.button.title' | translate }}\r\n        </div>\r\n        <div *ngIf=\"cardLinkOffer.OfferLocations == 2 || cardLinkOffer.OfferLocations == 3\" class=\"chip btn-instore\">\r\n          {{ 'fgbcl.card.linking.succes.offer.instore.button.title' | translate }}\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"offer-button-block\">\r\n    <button\r\n      (click)=\"offerAction(cardLinkOffer)\"\r\n      class=\"offer-button\"\r\n      [ngClass]=\"{\r\n        'add-offer': cardLinkOffer.CustomerOfferStatus == 0 && cardLinkOffer.OfferType == 6,\r\n        'added-offer': cardLinkOffer.CustomerOfferStatus == 1 && cardLinkOffer.OfferType == 6,\r\n        'view-offer': cardLinkOffer.OfferType != 6\r\n      }\"\r\n    >\r\n      <span *ngIf=\"cardLinkOffer.CustomerOfferStatus == 0 && cardLinkOffer.OfferType == 6\" class=\"icon material-icons\">\r\n        add\r\n      </span>\r\n      <span *ngIf=\"cardLinkOffer.CustomerOfferStatus == 1 && cardLinkOffer.OfferType == 6\" class=\"icon material-icons\">\r\n        done\r\n      </span>\r\n      <span *ngIf=\"cardLinkOffer.OfferType != 6\" class=\"icon material-icons\">navigate_next</span>\r\n    </button>\r\n  </div>\r\n</div>\r\n\r\n\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc2.CardLinkOffersService }, { type: ɵngcc3.Router }]; }, { cardLinkOffer: [{
            type: Input
        }], lcid: [{
            type: Input
        }] }); })();

class CardLinkOffersListComponent {
    constructor() { }
    ngOnInit() { }
}
CardLinkOffersListComponent.ɵfac = function CardLinkOffersListComponent_Factory(t) { return new (t || CardLinkOffersListComponent)(); };
CardLinkOffersListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CardLinkOffersListComponent, selectors: [["fgbcl-card-link-offers-list"]], inputs: { cardLinkOffers: "cardLinkOffers", lcid: "lcid" }, decls: 2, vars: 1, consts: [[1, "row"], [4, "ngFor", "ngForOf"], [1, "col-12", "col-lg-6"], [3, "cardLinkOffer", "lcid"]], template: function CardLinkOffersListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, CardLinkOffersListComponent_ng_container_1_Template, 3, 2, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.cardLinkOffers);
    } }, directives: [ɵngcc6.NgForOf, CardLinkOfferItemComponent], styles: [""] });
CardLinkOffersListComponent.ctorParameters = () => [];
CardLinkOffersListComponent.propDecorators = {
    cardLinkOffers: [{ type: Input }],
    lcid: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardLinkOffersListComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-card-link-offers-list',
                template: "<div class=\"row\">\r\n  <ng-container *ngFor=\"let cardLinkOffer of cardLinkOffers\">\r\n    <div class=\"col-12 col-lg-6\">\r\n      <fgbcl-card-link-offer-item\r\n        [cardLinkOffer]=\"cardLinkOffer\"\r\n        [lcid]=\"lcid\"\r\n      ></fgbcl-card-link-offer-item>\r\n    </div>\r\n  </ng-container>\r\n</div>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, { cardLinkOffers: [{
            type: Input
        }], lcid: [{
            type: Input
        }] }); })();

class CardLinkSuccessContentComponent {
    constructor() {
        this.googleIconName1 = 'credit_card';
        this.googleIconName2 = 'star';
        this.googleIconName3 = 'emoji_events';
    }
    ngOnInit() {
    }
}
CardLinkSuccessContentComponent.ɵfac = function CardLinkSuccessContentComponent_Factory(t) { return new (t || CardLinkSuccessContentComponent)(); };
CardLinkSuccessContentComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CardLinkSuccessContentComponent, selectors: [["fgbcl-card-link-success-content"]], decls: 18, vars: 12, consts: [[1, "card-link-success-icon-main-container"], [1, "card-link-success-icon-container"], [1, "icon", "material-icons"], [1, "card-link-success-text-btn-container"], [1, "text-title"], [1, "description-text"], ["type", "button", 1, "all-offer-btn"]], template: function CardLinkSuccessContentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "span", 2);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "span", 2);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 3);
        ɵngcc0.ɵɵelementStart(9, "p", 4);
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵpipe(11, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "p", 5);
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵpipe(14, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "button", 6);
        ɵngcc0.ɵɵtext(16);
        ɵngcc0.ɵɵpipe(17, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.googleIconName3);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.googleIconName1);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.googleIconName2);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(11, 6, "fgbcl.card.linking.success.content.title"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(14, 8, "fgbcl.card.linking.success.content.description"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(17, 10, "fgbcl.card.linking.success.all.offer.title"));
    } }, pipes: [ɵngcc5.TranslatePipe], styles: [""] });
CardLinkSuccessContentComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardLinkSuccessContentComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-card-link-success-content',
                template: "<div class=\"card-link-success-icon-main-container\">\r\n  <div class=\"card-link-success-icon-container\">\r\n    <span class=\"icon material-icons\">{{ googleIconName3 }}</span>\r\n    <span class=\"icon material-icons\">{{ googleIconName1 }}</span>\r\n    <span class=\"icon material-icons\">{{ googleIconName2 }}</span>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"card-link-success-text-btn-container\">\r\n  <p class=\"text-title\">{{'fgbcl.card.linking.success.content.title' | translate}}</p>\r\n  <p class=\"description-text\">{{'fgbcl.card.linking.success.content.description' | translate}}</p>\r\n  <button type=\"button\" class=\"all-offer-btn\">{{'fgbcl.card.linking.success.all.offer.title' | translate}}</button>\r\n</div>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, null); })();

class CardLinkedListComponent {
    constructor() {
        this.customOptions = {
            autoWidth: true,
            margin: OwlCarouselSettings.Margin,
            pullDrag: false,
            navSpeed: 700,
            navText: ['', ''],
            responsive: {
                0: { items: 1 },
                540: { items: 3 },
                740: { items: 5 },
            },
        };
    }
    ngOnInit() { }
}
CardLinkedListComponent.ɵfac = function CardLinkedListComponent_Factory(t) { return new (t || CardLinkedListComponent)(); };
CardLinkedListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CardLinkedListComponent, selectors: [["fgbcl-card-linked-list"]], inputs: { linkedCardList: "linkedCardList" }, decls: 3, vars: 2, consts: [[1, "card-link-list"], [3, "options"], [4, "ngFor", "ngForOf"], ["carouselSlide", "", 3, "width"], [3, "linkedCard"]], template: function CardLinkedListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "owl-carousel-o", 1);
        ɵngcc0.ɵɵtemplate(2, CardLinkedListComponent_2_Template, 1, 1, undefined, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("options", ctx.customOptions);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.linkedCardList);
    } }, directives: [ɵngcc8.CarouselComponent, ɵngcc6.NgForOf, ɵngcc8.CarouselSlideDirective, CardLinkedSingleComponent], styles: [""] });
CardLinkedListComponent.ctorParameters = () => [];
CardLinkedListComponent.propDecorators = {
    linkedCardList: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardLinkedListComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-card-linked-list',
                template: "\r\n<div class=\"card-link-list\">\r\n    <owl-carousel-o [options]=\"customOptions\">\r\n        <ng-template *ngFor=\"let card of linkedCardList\" carouselSlide [width]=\"220\">\r\n            <fgbcl-card-linked-single [linkedCard]=\"card\"></fgbcl-card-linked-single>\r\n        </ng-template>\r\n    </owl-carousel-o>\r\n</div>\r\n\r\n",
                styles: [""]
            }]
    }], function () { return []; }, { linkedCardList: [{
            type: Input
        }] }); })();

class CardLinkedTransactionsListComponent {
    constructor(transactionService, transactionQuery) {
        this.transactionService = transactionService;
        this.transactionQuery = transactionQuery;
        this.dateFormat = 'MMM DD, YYYY';
        this.transactionType = TransactionType.cardlink;
        this.keys = Object.keys;
        this.loading = false;
        this.hasTransactions = false;
        this.keepOrder = (a, b) => a.key;
    }
    ngOnInit() {
        this.transactionEndDate = this.transactionEndDate || new Date();
        this.transactionStartDate = new Date();
        this.transactionStartDate.setDate(new Date(this.transactionStartDate).getDate() - 1);
        this.getTransactions();
    }
    ngOnChanges(changes) {
        if (changes.startDate || changes.endDate || changes.transactionType) {
            if (changes.memberId) {
                this.getTransactions();
            }
        }
    }
    getTransactions() {
        this.loading = true;
        this.transactions$ = this.transactionService
            .fetchTransactions(this.transactionStartDate, this.transactionEndDate, this.memberId, this.transactionType)
            .pipe(switchMap(() => this.transactionQuery.selectTransactions(this.transactionStartDate, this.transactionEndDate, this.transactionType)), map((t) => {
            return this._groupByTransactionDate(t);
        }), tap((groupedTransactions) => {
            this.hasTransactions = Object.keys(groupedTransactions).length > 0;
            this.loading = false;
        }));
    }
    _groupByTransactionDate(transactions) {
        // sort by date descending
        const sorted = transactions.sort((a, b) => new Date(b.TransactionDateUTC).getTime() - new Date(a.TransactionDateUTC).getTime());
        // group into object with stringified dates as keys
        return sorted.reduce((grouped, tx) => {
            const txDate = moment(tx.TransactionDateUTC).format(this.dateFormat);
            if (grouped[txDate]) {
                grouped[txDate].push(tx);
            }
            else {
                grouped[txDate] = [tx];
            }
            return grouped;
        }, {});
    }
}
CardLinkedTransactionsListComponent.ɵfac = function CardLinkedTransactionsListComponent_Factory(t) { return new (t || CardLinkedTransactionsListComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.TransactionService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.TransactionQuery)); };
CardLinkedTransactionsListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CardLinkedTransactionsListComponent, selectors: [["fgbcl-card-linked-transactions-list"]], inputs: { dateFormat: "dateFormat", memberId: "memberId" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 27, vars: 22, consts: [[1, "card", "b-0", "mt-3", "mt-lg-0"], [1, "card-body", "p-3"], [1, "d-flex", "flex-column", "flex-lg-row", "justify-content-center"], [3, "startDate", "endDate", "startDateChange", "endDateChange"], ["type", "button", 1, "transaction-search-button", 3, "click"], [1, "container", "card-linked-transaction-list-header"], [1, "row", "p-2"], [1, "col-9"], [1, "row"], [1, "col-4", "d-none", "d-lg-block", "cardlink-transaction-label"], [1, "col-5", "d-none", "d-lg-block", "cardlink-transaction-label"], [1, "col-9", "d-lg-none", "cardlink-transaction-label"], [1, "col-3", "text-right"], [4, "ngIf"], ["class", "mt-4", 4, "ngIf"], ["class", "container card-linked-transaction-list-body", 4, "ngIf"], [1, "container", "card-linked-transaction-list-body"], [4, "ngFor", "ngForOf"], ["class", "row transaction-detail-row", 4, "ngFor", "ngForOf"], [1, "row", "transaction-detail-row"], [1, "col-9", "col-lg-4", "cardlink-transaction-date"], [1, "col-9", "col-lg-5", "font-weight-bold", "pr-0"], ["class", "font-weight-bold transaction-text text-capitalize", 3, "ngClass", 4, "ngIf"], ["class", "text-muted", 4, "ngIf"], [1, "font-weight-bold", "transaction-text", "text-capitalize", 3, "ngClass"], [1, "text-muted"], [1, "mt-4"], ["src", "assets/images/icons/no-transactions.svg", 1, "no-ecash-image", "d-flex", "mx-auto"], [1, "text-primary", "text-center", "mt-3", "mb-0", "font-weight-bold", "text-uppercase", "mt-4", "font-size-16"], [1, "text-info", "text-center", "font-size-12"]], template: function CardLinkedTransactionsListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "fgbcl-date-range-picker", 3);
        ɵngcc0.ɵɵlistener("startDateChange", function CardLinkedTransactionsListComponent_Template_fgbcl_date_range_picker_startDateChange_3_listener($event) { return ctx.transactionStartDate = $event; })("endDateChange", function CardLinkedTransactionsListComponent_Template_fgbcl_date_range_picker_endDateChange_3_listener($event) { return ctx.transactionEndDate = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "button", 4);
        ɵngcc0.ɵɵlistener("click", function CardLinkedTransactionsListComponent_Template_button_click_4_listener() { return ctx.getTransactions(); });
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵpipe(6, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 5);
        ɵngcc0.ɵɵelementStart(8, "div", 6);
        ɵngcc0.ɵɵelementStart(9, "div", 7);
        ɵngcc0.ɵɵelementStart(10, "div", 8);
        ɵngcc0.ɵɵelementStart(11, "div", 9);
        ɵngcc0.ɵɵtext(12);
        ɵngcc0.ɵɵpipe(13, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "div", 10);
        ɵngcc0.ɵɵtext(15);
        ɵngcc0.ɵɵpipe(16, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "div", 11);
        ɵngcc0.ɵɵtext(18);
        ɵngcc0.ɵɵpipe(19, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "div", 12);
        ɵngcc0.ɵɵtext(21);
        ɵngcc0.ɵɵpipe(22, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(23, CardLinkedTransactionsListComponent_ng_container_23_Template, 2, 1, "ng-container", 13);
        ɵngcc0.ɵɵpipe(24, "async");
        ɵngcc0.ɵɵtemplate(25, CardLinkedTransactionsListComponent_ng_container_25_Template, 9, 6, "ng-container", 13);
        ɵngcc0.ɵɵtemplate(26, CardLinkedTransactionsListComponent_div_26_Template, 2, 0, "div", 14);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("startDate", ctx.transactionStartDate)("endDate", ctx.transactionEndDate);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(6, 10, "fgbcl.card.linking.transaction.search.label"), " ");
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(13, 12, "fgbcl.card.linking.transaction.date.label"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(16, 14, "fgbcl.card.linking.transaction.description.label"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(19, 16, "fgbcl.card.linking.transaction.detail.label"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(22, 18, "fgbcl.card.linking.transaction.currency.label"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(24, 20, ctx.transactions$));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", (!ctx.transactions$ || !ctx.hasTransactions) && !ctx.loading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.loading);
    } }, directives: [ɵngcc9.DateRangePickerComponent, ɵngcc6.NgIf, ɵngcc6.NgForOf, ɵngcc6.NgClass, ɵngcc10.LoadingComponent], pipes: [ɵngcc5.TranslatePipe, ɵngcc6.AsyncPipe, ɵngcc6.KeyValuePipe, ɵngcc6.UpperCasePipe, ɵngcc7.UtcToLocaltimePipe, ɵngcc7.FortressCurrencyPipe], styles: [".no-ecash-image[_ngcontent-%COMP%]{height:75px}"] });
CardLinkedTransactionsListComponent.ctorParameters = () => [
    { type: TransactionService },
    { type: TransactionQuery }
];
CardLinkedTransactionsListComponent.propDecorators = {
    memberId: [{ type: Input }],
    dateFormat: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardLinkedTransactionsListComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-card-linked-transactions-list',
                template: "<div class=\"card b-0 mt-3 mt-lg-0\">\r\n  <div class=\"card-body p-3\">\r\n    <div class=\"d-flex flex-column flex-lg-row justify-content-center\">\r\n      <fgbcl-date-range-picker [(startDate)]=\"transactionStartDate\" [(endDate)]=\"transactionEndDate\"> </fgbcl-date-range-picker>\r\n      <button (click)=\"getTransactions()\" type=\"button\" class=\"transaction-search-button\">\r\n        {{ 'fgbcl.card.linking.transaction.search.label' | translate }}\r\n      </button>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"container card-linked-transaction-list-header\">\r\n  <div class=\"row p-2\">\r\n    <div class=\"col-9\">\r\n      <div class=\"row\">\r\n        <div class=\"col-4 d-none d-lg-block cardlink-transaction-label\">\r\n          {{ 'fgbcl.card.linking.transaction.date.label' | translate }}\r\n        </div>\r\n        <div class=\"col-5 d-none d-lg-block cardlink-transaction-label\">\r\n          {{ 'fgbcl.card.linking.transaction.description.label' | translate }}\r\n        </div>\r\n        <div class=\"col-9 d-lg-none cardlink-transaction-label\">\r\n          {{ 'fgbcl.card.linking.transaction.detail.label' | translate }}\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-3 text-right\">{{ 'fgbcl.card.linking.transaction.currency.label' | translate }}</div>\r\n  </div>\r\n</div>\r\n\r\n<ng-container *ngIf=\"transactions$ | async as transactions\">\r\n  <div *ngIf=\"hasTransactions\" class=\"container card-linked-transaction-list-body\">\r\n    <div *ngFor=\"let day of transactions | keyvalue: keepOrder\">\r\n      <div class=\"row transaction-detail-row\" *ngFor=\"let transaction of day.value\">\r\n        <div class=\"col-9\">\r\n          <div class=\"row\">\r\n            <div class=\"col-9 col-lg-4 cardlink-transaction-date\">\r\n              {{ transaction.TransactionDateUTC | UtcToLocaltimePipe: dateFormat | uppercase }}\r\n            </div>\r\n            <div class=\"col-9 col-lg-5 font-weight-bold pr-0\">{{ transaction.TransactionDescription }}</div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-3 text-right\">\r\n          <div\r\n            *ngIf=\"transaction.TransactionDescription != ''\"\r\n            class=\"font-weight-bold transaction-text text-capitalize\"\r\n            [ngClass]=\"transaction.Amount >= 0 ? 'text-success' : 'text-danger'\"\r\n          >\r\n            {{ transaction.Amount >= 0 ? '+' : '' }}{{ transaction.Amount | FortressCurrencyPipe: 'USD' }}\r\n          </div>\r\n          <div *ngIf=\"transaction.TransactionDescription == ''\" class=\"text-muted\">\r\n            {{ 'fgbcl.card.linking.transaction.status.pending.text' | translate }}\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n\r\n<ng-container *ngIf=\"(!transactions$ || !hasTransactions) && !loading\">\r\n  <div class=\"mt-4\">\r\n    <img class=\"no-ecash-image d-flex mx-auto\" src=\"assets/images/icons/no-transactions.svg\" />\r\n    <h5 class=\"text-primary text-center mt-3 mb-0 font-weight-bold text-uppercase mt-4 font-size-16\">\r\n      {{ 'fgbcl.card.linking.no.transaction.date.label' | translate }}\r\n    </h5>\r\n    <p class=\"text-info text-center font-size-12\">\r\n      {{ 'fgbcl.card.linking.no.transaction.date.description' | translate }}\r\n    </p>\r\n  </div>\r\n</ng-container>\r\n\r\n<div *ngIf=\"loading\" class=\"mt-4\">\r\n  <fgbcl-loading></fgbcl-loading>\r\n</div>\r\n",
                styles: [".no-ecash-image{height:75px}"]
            }]
    }], function () { return [{ type: ɵngcc2.TransactionService }, { type: ɵngcc2.TransactionQuery }]; }, { dateFormat: [{
            type: Input
        }], memberId: [{
            type: Input
        }] }); })();

class AffiliatesOffersCategoryFilterComponent {
    constructor() {
        this.categoryTagIdEmitter = new EventEmitter();
        this.categoryTagId = 0;
    }
    ngOnInit() { }
    categoryEmitter() {
        this.categoryTagIdEmitter.emit(this.categoryTagId);
    }
}
AffiliatesOffersCategoryFilterComponent.ɵfac = function AffiliatesOffersCategoryFilterComponent_Factory(t) { return new (t || AffiliatesOffersCategoryFilterComponent)(); };
AffiliatesOffersCategoryFilterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AffiliatesOffersCategoryFilterComponent, selectors: [["fgbcl-affiliates-offers-category-filter"]], inputs: { offerCategories: "offerCategories" }, outputs: { categoryTagIdEmitter: "categoryTagIdEmitter" }, decls: 2, vars: 1, consts: [[1, "affiliate-categories-block"], ["class", "category shadow-sm text-center mr-2", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "category", "shadow-sm", "text-center", "mr-2", 3, "ngClass", "click"], [1, "m-0"]], template: function AffiliatesOffersCategoryFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, AffiliatesOffersCategoryFilterComponent_div_1_Template, 3, 5, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.offerCategories);
    } }, directives: [ɵngcc6.NgForOf, ɵngcc6.NgClass], styles: [""] });
AffiliatesOffersCategoryFilterComponent.ctorParameters = () => [];
AffiliatesOffersCategoryFilterComponent.propDecorators = {
    offerCategories: [{ type: Input }],
    categoryTagIdEmitter: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AffiliatesOffersCategoryFilterComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-affiliates-offers-category-filter',
                template: "<div class=\"affiliate-categories-block\">\r\n  <div\r\n    *ngFor=\"let category of offerCategories\"\r\n    class=\"category shadow-sm text-center mr-2\"\r\n    [ngClass]=\"{ 'btn-selected': categoryTagId == category.TagId, 'btn-not-selected': categoryTagId != category.TagId }\"\r\n    (click)=\"categoryTagId = category.TagId; categoryEmitter()\"\r\n  >\r\n    <p class=\"m-0\">{{ category.Name }}</p>\r\n  </div>\r\n</div>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, { categoryTagIdEmitter: [{
            type: Output
        }], offerCategories: [{
            type: Input
        }] }); })();

class CardLinkOfferDetailsComponent {
    constructor(memberQuery, modalService, cardLinkOffersService) {
        this.memberQuery = memberQuery;
        this.modalService = modalService;
        this.cardLinkOffersService = cardLinkOffersService;
        this.currentTab = 'description';
        this._destroyed$ = new Subject();
        this.clubImageUrl = '../../../assets/images/assets/images/logo.svg';
    }
    ngOnInit() {
        this.currentLcid = this.memberQuery.getUserContext().lcid;
    }
    /**
    * to prevent multiple calls
    * fromEvent will make click action to button string
    * and the in pipe exhaustMap will make the call to api for fatch url
    * and privent if user click multiple time
    * after subscription will check if url exist then move to url
    */
    ngAfterViewInit() {
        fromEvent(this.shopNowBtn.nativeElement, 'click')
            .pipe(exhaustMap(() => this.fatchNavigationtoOfferUrl()), takeUntil(this._destroyed$))
            .subscribe((activateOffer) => {
            this.cardLinkActivateOffer = activateOffer;
            if (activateOffer && activateOffer.ErrorDescription == 'Success') {
                this.openModel(this.modelContent);
                if (activateOffer.RedirectUrl.includes('http')) {
                    setTimeout(() => {
                        window.location.href = activateOffer.RedirectUrl;
                    }, 3000);
                }
            }
        });
    }
    /**
     * fatch the URL from Navigation
     */
    fatchNavigationtoOfferUrl() {
        return this.cardLinkOffersService.companiesClaim(this.selectedOffer.OfferId);
    }
    /**
     * open model to display the navigation progress
     * @param content to open the ngbModel to display the navigation progress
     */
    openModel(content) {
        this.modalService.open(content, { centered: true, windowClass: 'card-link-navigation-url-model-custom-size' });
    }
    /**
     * Unsubscribe the observables on distroy
     */
    ngOnDestroy() {
        this._destroyed$.next();
        this._destroyed$.complete();
    }
}
CardLinkOfferDetailsComponent.ɵfac = function CardLinkOfferDetailsComponent_Factory(t) { return new (t || CardLinkOfferDetailsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.MemberQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgbModal), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.CardLinkOffersService)); };
CardLinkOfferDetailsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CardLinkOfferDetailsComponent, selectors: [["fgbcl-card-link-offer-details"]], viewQuery: function CardLinkOfferDetailsComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c3, 1);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.shopNowBtn = _t.first);
    } }, inputs: { cardLinkOfferDtail: "cardLinkOfferDtail" }, decls: 38, vars: 37, consts: [[1, "offer-detail-main-block"], [1, "offer-bg-image-block"], [1, "shadow-sm", "rounded-lg", 3, "src"], [1, "offer-detail-block"], [1, "offer-detail-img-name-block"], [1, "offer-detail-image-block"], [1, "offer-detail-image"], [3, "src"], [1, "offer-name-title"], [1, "offer-detail-text-block"], [1, "feature-Offer-text"], [1, "icon", "material-icons"], [1, "offer-detail-description"], ["class", "btn-online-instore-block", 4, "ngIf"], [1, "offer-details-tabs"], [3, "ngClass", "click"], [4, "ngIf"], [1, "offer-details-tabs-text"], [1, "horizontal-line"], ["class", "btn btn-success", 4, "ngIf"], ["class", "btn shop-now", 3, "click", 4, "ngIf"], ["class", "d-flex flex-row align-items-center justify-content-center", 4, "ngIf"], ["content", ""], [1, "btn-online-instore-block"], ["class", "chip btn-online", 4, "ngIf"], ["class", "chip btn-instore", 4, "ngIf"], [1, "chip", "btn-online"], [1, "chip", "btn-instore"], [1, "btn", "btn-success"], [1, "btn", "shop-now", 3, "click"], ["shopNowBtn", ""], [1, "d-flex", "flex-row", "align-items-center", "justify-content-center"], [1, "offer-button", "added-offer", "mt-0"], [1, "text-success", "mb-0", "ml-2", "mt-0"], [3, "companyImageUrl", "navigationUrl", "clubImageUrl"]], template: function CardLinkOfferDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "img", 2);
        ɵngcc0.ɵɵpipe(3, "contentImage");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵelementStart(6, "div", 5);
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵelement(8, "img", 7);
        ɵngcc0.ɵɵpipe(9, "contentImage");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "p", 8);
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵpipe(12, "currentLanguageContent");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 9);
        ɵngcc0.ɵɵelementStart(14, "p", 10);
        ɵngcc0.ɵɵelementStart(15, "span", 11);
        ɵngcc0.ɵɵtext(16, "star");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(17);
        ɵngcc0.ɵɵpipe(18, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "p", 12);
        ɵngcc0.ɵɵtext(20);
        ɵngcc0.ɵɵpipe(21, "shortText");
        ɵngcc0.ɵɵpipe(22, "currentLanguageContent");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(23, CardLinkOfferDetailsComponent_div_23_Template, 3, 2, "div", 13);
        ɵngcc0.ɵɵelementStart(24, "div", 14);
        ɵngcc0.ɵɵelementStart(25, "p", 15);
        ɵngcc0.ɵɵlistener("click", function CardLinkOfferDetailsComponent_Template_p_click_25_listener() { return ctx.currentTab = "description"; });
        ɵngcc0.ɵɵtext(26);
        ɵngcc0.ɵɵpipe(27, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(28, CardLinkOfferDetailsComponent_ng_container_28_Template, 4, 6, "ng-container", 16);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(29, "div", 17);
        ɵngcc0.ɵɵelement(30, "hr", 18);
        ɵngcc0.ɵɵtemplate(31, CardLinkOfferDetailsComponent_p_31_Template, 3, 5, "p", 16);
        ɵngcc0.ɵɵtemplate(32, CardLinkOfferDetailsComponent_p_32_Template, 2, 1, "p", 16);
        ɵngcc0.ɵɵtemplate(33, CardLinkOfferDetailsComponent_button_33_Template, 3, 3, "button", 19);
        ɵngcc0.ɵɵtemplate(34, CardLinkOfferDetailsComponent_button_34_Template, 4, 3, "button", 20);
        ɵngcc0.ɵɵtemplate(35, CardLinkOfferDetailsComponent_div_35_Template, 7, 3, "div", 21);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(36, CardLinkOfferDetailsComponent_ng_template_36_Template, 1, 3, "ng-template", null, 22, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("src", ɵngcc0.ɵɵpipeBind2(3, 14, ctx.cardLinkOfferDtail.ImageUrl, "6"), ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("src", ɵngcc0.ɵɵpipeBind2(9, 17, ctx.cardLinkOfferDtail.CompanyImageUrl, "7"), ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind3(12, 20, ctx.cardLinkOfferDtail.Content, ctx.currentLcid, "Name"));
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(18, 24, "fgbcl.card.linking.feature.offer.title"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(21, 26, ɵngcc0.ɵɵpipeBind3(22, 29, ctx.cardLinkOfferDtail.Content, ctx.currentLcid, "description"), 45), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.cardLinkOfferDtail.OfferLocations != 0);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(35, _c4, ctx.currentTab != "description"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(27, 33, "fgbcl.offer.detail.tab-text-desc"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.cardLinkOfferDtail.TermsAndConditions);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.currentTab == "description");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.currentTab == "viewexemptios");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.cardLinkOfferDtail.CustomerOfferStatus == 0 && ctx.cardLinkOfferDtail.OfferType == 6);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.cardLinkOfferDtail.OfferType != 6);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.cardLinkOfferDtail.CustomerOfferStatus == 1 && ctx.cardLinkOfferDtail.OfferType == 6);
    } }, directives: function () { return [ɵngcc6.NgIf, ɵngcc6.NgClass, CardLinkExternalUrlModalComponent]; }, pipes: function () { return [ɵngcc7.ContentImagePipe, ɵngcc7.ContentLanguageFilterPipe, ɵngcc5.TranslatePipe, ɵngcc7.LongtoShortTextPipe]; }, styles: [""] });
CardLinkOfferDetailsComponent.ctorParameters = () => [
    { type: MemberQuery },
    { type: NgbModal },
    { type: CardLinkOffersService }
];
CardLinkOfferDetailsComponent.propDecorators = {
    shopNowBtn: [{ type: ViewChild, args: ['shopNowBtn',] }],
    cardLinkOfferDtail: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardLinkOfferDetailsComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-card-link-offer-details',
                template: "<div class=\"offer-detail-main-block\">\r\n  <div class=\"offer-bg-image-block\">\r\n    <img class=\"shadow-sm rounded-lg\" [src]=\"cardLinkOfferDtail.ImageUrl | contentImage: '6'\" />\r\n  </div>\r\n\r\n  <div class=\"offer-detail-block\">\r\n    <div class=\"offer-detail-img-name-block\">\r\n      <div class=\"offer-detail-image-block\">\r\n        <div class=\"offer-detail-image\">\r\n          <img [src]=\"cardLinkOfferDtail.CompanyImageUrl | contentImage: '7'\" />\r\n        </div>\r\n      </div>\r\n      <p class=\"offer-name-title\">{{ cardLinkOfferDtail.Content | currentLanguageContent: currentLcid:'Name' }}</p>\r\n    </div>\r\n\r\n    <div class=\"offer-detail-text-block\">\r\n      <p class=\"feature-Offer-text\">\r\n        <span class=\"icon material-icons\">star</span>{{ 'fgbcl.card.linking.feature.offer.title' | translate }}\r\n      </p>\r\n\r\n      <p class=\"offer-detail-description\">\r\n        {{ cardLinkOfferDtail.Content | currentLanguageContent: currentLcid:'description' | shortText: 45 }}\r\n      </p>\r\n\r\n      <div *ngIf=\"cardLinkOfferDtail.OfferLocations != 0\" class=\"btn-online-instore-block\">\r\n        <div *ngIf=\"cardLinkOfferDtail.OfferLocations == 1 || cardLinkOfferDtail.OfferLocations == 3\" class=\"chip btn-online\">\r\n          {{ 'fgbcl.card.linking.succes.offer.online.button.title' | translate }}\r\n        </div>\r\n        <div *ngIf=\"cardLinkOfferDtail.OfferLocations == 2 || cardLinkOfferDtail.OfferLocations == 3\" class=\"chip btn-instore\">\r\n          {{ 'fgbcl.card.linking.succes.offer.instore.button.title' | translate }}\r\n        </div>\r\n      </div>\r\n      <div class=\"offer-details-tabs\">\r\n        <p [ngClass]=\"{ 'tab-disable': currentTab != 'description' }\" (click)=\"currentTab = 'description'\">\r\n          {{ 'fgbcl.offer.detail.tab-text-desc' | translate }}\r\n        </p>\r\n        <ng-container *ngIf=\"cardLinkOfferDtail.TermsAndConditions\">\r\n          <p [ngClass]=\"{ 'tab-disable': currentTab != 'viewexemptios' }\" (click)=\"currentTab = 'viewexemptios'\">\r\n            {{ 'fgbcl.offer.detail.tab-viewexem-text' | translate }}\r\n          </p>\r\n        </ng-container>\r\n      </div>\r\n    </div>\r\n    <div class=\"offer-details-tabs-text\">\r\n      <hr class=\"horizontal-line\" />\r\n      <p *ngIf=\"currentTab == 'description'\">\r\n        {{ cardLinkOfferDtail.Content | currentLanguageContent: currentLcid:'description' }}\r\n      </p>\r\n      <p *ngIf=\"currentTab == 'viewexemptios'\">\r\n        <ng-container *ngIf=\"cardLinkOfferDtail.TermsAndConditionsType == 1\">\r\n          {{ cardLinkOfferDtail.TermsAndConditions }}\r\n        </ng-container>\r\n      </p>\r\n\r\n      <button *ngIf=\"cardLinkOfferDtail.CustomerOfferStatus == 0 && cardLinkOfferDtail.OfferType == 6\" class=\"btn btn-success\">\r\n        {{ 'fgbcl.offer.detail.activate.offer.button.text' | translate }}\r\n      </button>\r\n      <button\r\n        #shopNowBtn\r\n        (click)=\"selectedOffer = cardLinkOfferDtail; modelContent = content\"\r\n        *ngIf=\"cardLinkOfferDtail.OfferType != 6\"\r\n        class=\"btn shop-now\"\r\n      >\r\n        {{ 'fgbcl.offer.detail.shop.now.button.text' | translate }}\r\n      </button>\r\n      <div\r\n        class=\"d-flex flex-row align-items-center justify-content-center\"\r\n        *ngIf=\"cardLinkOfferDtail.CustomerOfferStatus == 1 && cardLinkOfferDtail.OfferType == 6\"\r\n      >\r\n        <button class=\"offer-button added-offer mt-0\"><span class=\"icon material-icons\">done</span></button>\r\n        <p class=\"text-success mb-0 ml-2 mt-0\">\r\n          {{ 'fgbcl.offer.detail.activated.offer.button.text' | translate }}\r\n        </p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<ng-template #content let-modal>\r\n  <fgbcl-card-link-external-url-modal\r\n    [companyImageUrl]=\"selectedOffer.CompanyImageUrl\"\r\n    [navigationUrl]=\"cardLinkActivateOffer.RedirectUrl\"\r\n    [clubImageUrl]=\"clubImageUrl\"\r\n  ></fgbcl-card-link-external-url-modal>\r\n</ng-template>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc2.MemberQuery }, { type: ɵngcc1.NgbModal }, { type: ɵngcc2.CardLinkOffersService }]; }, { shopNowBtn: [{
            type: ViewChild,
            args: ['shopNowBtn']
        }], cardLinkOfferDtail: [{
            type: Input
        }] }); })();

class CardLinkExternalUrlModalComponent {
    constructor() { }
    ngOnInit() { }
}
CardLinkExternalUrlModalComponent.ɵfac = function CardLinkExternalUrlModalComponent_Factory(t) { return new (t || CardLinkExternalUrlModalComponent)(); };
CardLinkExternalUrlModalComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CardLinkExternalUrlModalComponent, selectors: [["fgbcl-card-link-external-url-modal"]], inputs: { companyImageUrl: "companyImageUrl", clubImageUrl: "clubImageUrl", navigationUrl: "navigationUrl" }, decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["noUrl", ""], [1, "card-link-external-url-model-header"], [1, "modal-body"], [1, "app-container"], [1, "offer-item"], [1, "offer-item-image"], [3, "src"], [1, "all-arrows-container"], [1, "arrows-container"], ["aria-hidden", "true", 1, "icon", "material-icons", "arrow", "arrow-one", "left"], ["aria-hidden", "true", 1, "icon", "material-icons", "arrow", "arrow-two", "left"], [1, "my-4"], [1, "text-center"], [1, "click-here", 3, "href"], [1, "m-4"], [1, "text-center", "text-danger", "font-size-24", "font-weight-bold"]], template: function CardLinkExternalUrlModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, CardLinkExternalUrlModalComponent_ng_container_0_Template, 39, 24, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, CardLinkExternalUrlModalComponent_ng_template_1_Template, 4, 3, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.navigationUrl.includes("http"))("ngIfElse", _r1);
    } }, directives: [ɵngcc6.NgIf], pipes: [ɵngcc5.TranslatePipe, ɵngcc7.ContentImagePipe], styles: [""] });
CardLinkExternalUrlModalComponent.ctorParameters = () => [];
CardLinkExternalUrlModalComponent.propDecorators = {
    companyImageUrl: [{ type: Input }],
    clubImageUrl: [{ type: Input }],
    navigationUrl: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardLinkExternalUrlModalComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-card-link-external-url-modal',
                template: "<ng-container *ngIf=\"navigationUrl.includes('http'); else noUrl\">\r\n  <div class=\"card-link-external-url-model-header\">\r\n    <h1>\r\n      {{ 'fgbcl.card.link.external.url.model.title' | translate }}\r\n    </h1>\r\n    <p>{{ 'fgbcl.card.link.external.url.model.description' | translate }} - Earn 1 Point per 1</p>\r\n  </div>\r\n  <div class=\"modal-body\">\r\n    <div class=\"app-container\">\r\n      <div class=\"offer-item\">\r\n        <div class=\"offer-item-image\">\r\n          <img [src]=\"clubImageUrl | contentImage:'7'\" />\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"all-arrows-container\">\r\n        <div class=\"arrows-container\">\r\n          <div class=\"icon material-icons arrow arrow-one left\" aria-hidden=\"true\">arrow_forward_ios</div>\r\n          <div class=\"icon material-icons arrow arrow-two left\" aria-hidden=\"true\">arrow_forward_ios</div>\r\n        </div>\r\n        <div class=\"arrows-container\">\r\n          <div class=\"icon material-icons arrow arrow-one left\" aria-hidden=\"true\">arrow_forward_ios</div>\r\n          <div class=\"icon material-icons arrow arrow-two left\" aria-hidden=\"true\">arrow_forward_ios</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"offer-item\">\r\n        <div class=\"offer-item-image\">\r\n          <img [src]=\"companyImageUrl | contentImage:'7'\" />\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"my-4\">\r\n    <p class=\"text-center\">\r\n      {{ 'fgbcl.card.link.external.url.model.first.instruction' | translate }}\r\n      <a href=\"{{ navigationUrl }}\" class=\"click-here\"\r\n        ><strong>{{ 'fgbcl.card.link.external.url.model.click.here' | translate }}</strong></a\r\n      >\r\n      {{ 'fgbcl.card.link.external.url.model.second.instruction' | translate }}\r\n    </p>\r\n  </div>\r\n</ng-container>\r\n\r\n<ng-template #noUrl>\r\n  <div class=\"m-4\">\r\n    <p class=\"text-center text-danger font-size-24 font-weight-bold\">\r\n      {{ 'fgbcl.card.link.external.wrong.url.text' | translate }}</p>\r\n  </div>\r\n</ng-template>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, { companyImageUrl: [{
            type: Input
        }], clubImageUrl: [{
            type: Input
        }], navigationUrl: [{
            type: Input
        }] }); })();

class CardLinkingFeaturedOffersComponent {
    constructor(memberQuery, cardLinkOffersQuery, cardLinkOffersService) {
        this.memberQuery = memberQuery;
        this.cardLinkOffersQuery = cardLinkOffersQuery;
        this.cardLinkOffersService = cardLinkOffersService;
        this.numberOfOffers = 3;
        this.customOptions = {
            autoHeight: true,
            autoWidth: true,
            margin: OwlCarouselSettings.Margin,
            autoplay: OwlCarouselSettings.Autoplay,
            autoplayTimeout: OwlCarouselSettings.AutoplayTimeout,
            autoplaySpeed: OwlCarouselSettings.AutoplaySpeed,
            navSpeed: 700,
            navText: ['', ''],
            responsive: {
                0: { items: 1 },
                740: { items: 2 },
                900: { items: 3 },
            },
        };
    }
    ngOnInit() {
        this.currentLcid = this.memberQuery.getUserContext().lcid;
        this.cardLinkOffersService.fatchAffiliateOffer().toPromise();
        this.featuredOffers$ = this.cardLinkOffersQuery.featuredOffers(this.numberOfOffers);
    }
}
CardLinkingFeaturedOffersComponent.ɵfac = function CardLinkingFeaturedOffersComponent_Factory(t) { return new (t || CardLinkingFeaturedOffersComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.MemberQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.CardLinkOffersQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.CardLinkOffersService)); };
CardLinkingFeaturedOffersComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CardLinkingFeaturedOffersComponent, selectors: [["fgbcl-card-linking-featured-offers"]], inputs: { numberOfOffers: "numberOfOffers" }, decls: 2, vars: 3, consts: [[4, "ngIf"], ["class", "row", 4, "ngIf"], [1, "row"], [1, "col-12"], [3, "options"], [4, "ngFor", "ngForOf"], ["carouselSlide", "", 3, "width"], [1, "cardlink-featured-offer-block", "shadow-sm", "rounded"], [1, "featured-offer-bg-img"], [3, "src"], [1, "offer-item", "feature-offer-image"], [1, "offer-item-image"], [1, "feature-content-block"], [1, "feature-offer-name-title"], [1, "font-size-14"], [1, "btn-online-instore-block"], ["class", "chip btn-online", 4, "ngIf"], ["class", "chip btn-instore", 4, "ngIf"], [1, "chip", "btn-online"], [1, "chip", "btn-instore"]], template: function CardLinkingFeaturedOffersComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, CardLinkingFeaturedOffersComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.featuredOffers$));
    } }, directives: [ɵngcc6.NgIf, ɵngcc8.CarouselComponent, ɵngcc6.NgForOf, ɵngcc8.CarouselSlideDirective], pipes: [ɵngcc6.AsyncPipe, ɵngcc7.ContentImagePipe, ɵngcc7.ContentLanguageFilterPipe, ɵngcc7.LongtoShortTextPipe, ɵngcc5.TranslatePipe], styles: [""] });
CardLinkingFeaturedOffersComponent.ctorParameters = () => [
    { type: MemberQuery },
    { type: CardLinkOffersQuery },
    { type: CardLinkOffersService }
];
CardLinkingFeaturedOffersComponent.propDecorators = {
    numberOfOffers: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardLinkingFeaturedOffersComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-card-linking-featured-offers',
                template: "\r\n<ng-container *ngIf=\"featuredOffers$ | async as featuredOffers\">\r\n  <div class=\"row\" *ngIf=\"!!featuredOffers.length\">\r\n    <div class=\"col-12\">\r\n      <owl-carousel-o [options]=\"customOptions\">\r\n        <ng-container *ngFor=\"let offer of featuredOffers\">\r\n          <ng-template carouselSlide [width]=\"301\">\r\n            <div class=\"cardlink-featured-offer-block shadow-sm rounded\">\r\n              <div class=\"featured-offer-bg-img\">\r\n                <img [src]=\"offer.ImageUrl | contentImage: '6'\" />\r\n              </div>\r\n              <div class=\"offer-item feature-offer-image\">\r\n                <div class=\"offer-item-image\">\r\n                  <img [src]=\"offer.CompanyImageUrl | contentImage: '6'\" />\r\n                </div>\r\n              </div>\r\n              <div class=\"feature-content-block\">\r\n                <p class=\"feature-offer-name-title\">{{ offer.Content | currentLanguageContent: currentLcid:'Name' }}</p>\r\n                <p class=\"font-size-14\">\r\n                  {{ offer.Content | currentLanguageContent: currentLcid:'description' | shortText: 30 }}\r\n                </p>\r\n              </div>\r\n              <div class=\"btn-online-instore-block\">\r\n                <div *ngIf=\"offer.OfferLocations == 1 || offer.OfferLocations == 3\" class=\"chip btn-online\">\r\n                  {{ 'fgbcl.card.linking.succes.offer.online.button.title' | translate }}\r\n                </div>\r\n                <div *ngIf=\"offer.OfferLocations == 2 || offer.OfferLocations == 3\" class=\"chip btn-instore\">\r\n                  {{ 'fgbcl.card.linking.succes.offer.instore.button.title' | translate }}\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </ng-template>\r\n        </ng-container>\r\n      </owl-carousel-o>\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n\r\n\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc2.MemberQuery }, { type: ɵngcc2.CardLinkOffersQuery }, { type: ɵngcc2.CardLinkOffersService }]; }, { numberOfOffers: [{
            type: Input
        }] }); })();

class CardLinkModule {
}
CardLinkModule.ɵfac = function CardLinkModule_Factory(t) { return new (t || CardLinkModule)(); };
CardLinkModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CardLinkModule });
CardLinkModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            NgbModule,
            DateRangePickerModule,
            PipesModule,
            CarouselModule,
            LoadingModule,
            RouterModule,
            DirectivesModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CardLinkModule, { declarations: function () { return [CardLinkButtonComponent, CardLinkedSingleComponent, CardLinkedListComponent, CardLinkedTransactionsListComponent, CardLinkSuccessContentComponent, CardLinkOfferItemComponent, CardLinkOffersListComponent, AffiliatesOffersCategoryFilterComponent, CardLinkOfferDetailsComponent, CardLinkExternalUrlModalComponent, CardLinkingFeaturedOffersComponent]; }, imports: function () { return [CommonModule,
        NgbModule,
        DateRangePickerModule,
        PipesModule,
        CarouselModule,
        LoadingModule,
        RouterModule,
        DirectivesModule, ɵngcc5.TranslateModule]; }, exports: function () { return [CardLinkButtonComponent, CardLinkedSingleComponent, CardLinkedListComponent, CardLinkedTransactionsListComponent, CardLinkSuccessContentComponent, CardLinkOfferItemComponent, CardLinkOffersListComponent, AffiliatesOffersCategoryFilterComponent, CardLinkOfferDetailsComponent, CardLinkExternalUrlModalComponent, CardLinkingFeaturedOffersComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardLinkModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CardLinkButtonComponent,
                    CardLinkedSingleComponent,
                    CardLinkedListComponent,
                    CardLinkedTransactionsListComponent,
                    CardLinkSuccessContentComponent,
                    CardLinkOfferItemComponent,
                    CardLinkOffersListComponent,
                    AffiliatesOffersCategoryFilterComponent,
                    CardLinkOfferDetailsComponent,
                    CardLinkExternalUrlModalComponent,
                    CardLinkingFeaturedOffersComponent,
                ],
                imports: [
                    CommonModule,
                    NgbModule,
                    DateRangePickerModule,
                    PipesModule,
                    CarouselModule,
                    LoadingModule,
                    RouterModule,
                    DirectivesModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [
                    CardLinkButtonComponent,
                    CardLinkedSingleComponent,
                    CardLinkedListComponent,
                    CardLinkedTransactionsListComponent,
                    CardLinkSuccessContentComponent,
                    CardLinkOfferItemComponent,
                    CardLinkOffersListComponent,
                    AffiliatesOffersCategoryFilterComponent,
                    CardLinkOfferDetailsComponent,
                    CardLinkExternalUrlModalComponent,
                    CardLinkingFeaturedOffersComponent
                ]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { AffiliatesOffersCategoryFilterComponent, CardLinkButtonComponent, CardLinkExternalUrlModalComponent, CardLinkModule, CardLinkOfferDetailsComponent, CardLinkOfferItemComponent, CardLinkOffersListComponent, CardLinkSuccessContentComponent, CardLinkedListComponent, CardLinkedSingleComponent, CardLinkedTransactionsListComponent, CardLinkingFeaturedOffersComponent };

//# sourceMappingURL=fgb-portal-component-library-src-lib-cardlinking.js.map